export default "__VITE_ASSET__BvyUW08l__"